import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ModalService {
	static closeModal: EventEmitter<any> = new EventEmitter<any>();
	constructor() {}
}
